<template>
  <div id="register-page" class="content">
    <template v-if="disclaimer == false">
      <h3>Register for Access</h3>
      <form @submit.prevent="register">
        <p>
        <label>First Name
          <input type="text" name="firstname" v-model="user.firstname" required>
        </label>
        </p>
        <p>
        <label>Last Name
          <input type="text" name="lastname" v-model="user.lastname" required>
        </label>
        </p>
        <p>
        <label>Industry Role
          <input type="text" name="industry_role" v-model="user.industry_role" placeholder="Select or enter your role" list="role_list" autocomplete="one-time-code" required>
          <datalist id="role_list">
            <option value="Bank Office/Operations" />
            <option value="Data Provider" />
            <option value="Trustee" />
            <option value="Lender" />
            <option value="Investor" />
            <option value="Issuer" />
            <option value="NSRO" />
            <option value="Servicer" />
            <option value="Underwriter" />
          </datalist>
        </label>
        </p>
        <p>
        <label>Company
          <input type="text" name="company" v-model="user.company" required>
        </label>
        </p>
        <p>
        <label>Address
          <input type="text" name="address" v-model="user.address" required>
        </label>
        </p>
        <p>
        <label>Suite/Apt
          <input type="text" name="address2" v-model="user.address2">
        </label>
        </p>
        <p>
        <label>City
          <input type="text" name="city" v-model="user.city" required>
        </label>
        </p>
        <p>
        <label>State
          <input type="text" name="state" v-model="user.state" required>
        </label>
        </p>
        <p>
        <label>ZIP Code
          <input type="text" name="zipcode" v-model="user.zipcode" inputmode="numeric" required>
        </label>
        </p>
        <p>
        <label>Email
          <input type="email" name="email" v-model="user.email" required>
        </label>
        </p>
        <p>
        <label>Work Phone
          <input type="tel" name="workphone" v-model="user.work_phone">
        </label>
        </p>
        <p>
        <label>User ID
          <input type="text" name="user" v-model="user.username" required>
        </label>
        </p>
        <p>
        <label>Password
          <input type="password" name="password" v-model="user.password" required>
        </label>
        </p>
        <p>
        <button>Create Account</button>
        </p>
        <p v-if="errorMsg" class="error">
          {{errorMsg}}
        </p>
        <p class="login">
        Have an account?
        <router-link to="/login">Log In</router-link>
        </p>
      </form>
    </template>
    <template v-else>
      <div class="disclaimer">
        <div class="text">
          <h3>Access To Services</h3>
          <p><strong>WSFS ABS REPORTING</strong> is provided as a convenience to customers and business partners of Wilmington Savings Fund Society, FSB (the “WSFS”) Institutional Services, Corporate Trust. Access is provided via a single on-line registration however additional approval may be required for some services.</p>
          <p>ANYONE attempting to gain access to these services beyond their assigned access level or use a name other than their LEGAL name or derivative may BE PROSECUTED as the law provides under Public Law 99-508 Section 2701.</p>
          <p><strong>WSFS ABS REPORTING</strong> provides a direct link to collateral and bond information on a variety of investment vehicles administered by the Corporate Trust group of Wilmington Savings Fund Socierty, FSB Institutional Services of all Asset Backed Securities.</p>  

          <h3>Electronic Messages</h3>
          <p>ANYONE accessing this information service and leaving any comments or messages on these services grants the Business Group and/or the Technical Team the specific right to read and dispose of the communication as the Teams determine to be a proper disposition.</p>
          <p><strong>Notice:</strong> The following notice is made available as per Federal Requirements, pursuant to the Electronic and Communications Privacy Act of 1986, Title 18 of the United States Code, Section 2701 et. seq., notice is hereby given that there are no facilities provided by this information service for sending or receiving private or confidential electronic communications. All messages can and may be read by the WSFS Corportate Trust Team and the Technical Team.</p>
          <p>The foregoing statements apply EQUALLY to the main information service and to ANY conference this information service establishes or in which it participates.</p>
          <p>ANYONE leaving ANY communication on this information service grants unrestricted and total public access to such communication, however only the Business Group and/or the Technical Team will have direct access to such communication.</p>

          <h3>Data Declarations</h3>
          <p>Any information provided on these services is intended for the sole purpose of reporting, transferring and/or reconcilement of business data. The various documents posted to the investor reporting web sites are made available here solely as a convenience at the request of the issuers and not for the purpose of furthering the securities offerings. Their availability here is in no way a solicitation or an offer to buy or sell the securities referenced.</p>
          <p>Although reasonable care has been exercised to receive data on sites providing file transfer capabilities, there can be no assurance that this information has been received until receipt of confirmation has been provided.</p>
          <p>Any downloading and use of files on our sites is done at the user's own risk. Every effort is made to ensure there are no "infected" programs on this environment; however we are not liable for any damage to hardware or data that may occur as a result of using these services.</p>
          <p>All users are responsible to check all files for possible viruses. We strongly advise that you set up a routine to check all software, whether obtained from an information service or a commercial vendor, for viruses.</p>
        </div>
        <div class="buttons">
          <button @click.prevent="disclaimer = false">I Agree</button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'register-page',
  data() {
    return {
      user: {},
      confirmPassword: '',
      disclaimer: true,
      errorMsg: null,
    }
  },
  methods: {
    async register() {
      let r;
      try {
        r = await axios.post('/api/users', {user: this.user})
      }
      catch (ex) {
        // console.dir(ex);
        this.$notify.error(`Could not create account: ${ex.response.data.message}`, 5000)
        return;
      }


      this.$notify.success('Account Created. Login below.', 3000)
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
@import "../scss/include-media";

#register-page {
  padding: 50px 100px;
  @include media("<=tablet") {
    padding: 50px;
  }
  &.content {
    @include media(">=tablet") {
      max-width: 610px;
    }
  }

  display: flex;
  flex-flow: column;

  p {
    margin-bottom: 1.25rem;
    &.login {
      text-align: center;
    }
  }

  button {
    padding: 1rem 1.25rem;
    width: 100%;
    display: block;
    text-transform: uppercase;
  }

  h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  .disclaimer {
    .text {
      border: solid 1px #eaeaea;
      @include media('>=tablet') {
        max-height: 55vh;
      }
      @include media('<tablet') {
        max-height: 75vh;
      }
      padding: 8px;
      overflow: auto;

      h3 {
        text-align: left;
      }
    }
    .buttons {
      margin-top: 1rem;
    }
  }

}
</style>
